var BackOffice = (function(backOffice, $) {

	var render = function() {
			$(".page-wrap").tooltip({
				selector: ".bstitle"
			});

			$(".bspopover").popover({
				//container: '.page-wrap',
				selector: { padding: "100px" }
			});

			//  Fixing Telerik IE10 bug - http://www.telerik.com/forums/getting-a-unable-to-get-property-documentelement-of-undefined-or-null-reference-error
			if (typeof window.$telerik != "undefined") {
				if (
					typeof window.$telerik.getLocation == "function" &&
					Sys.Browser.agent == Sys.Browser.InternetExplorer &&
					Sys.Browser.version == 10
				) {
					window.$telerik.getLocation = function(a) {
						if (a === document.documentElement) {
							return new Sys.UI.Point(0, 0);
						}
						var offset = $(a).offset();
						return new Sys.UI.Point(offset.left, offset.top);
					};
				}
			}

			BackOffice.PopulateMandatoryFields();
		},
		events = function() {
			$(".glyphicon-calendar").on("click", function() {
				//  force glyph click to initiate datepicker
				var picker = $(this).prev();
				picker.trigger("focus");
			});

			//  set the value of the selected tab (classic pages only)
			$("li[data-tab]").click(function() {
				$("#pageTab").val($(this).attr("data-tab"));
			});

			$(document).on("submit", "form", function() {
				if (BackOffice.ValidateForm($(this))) {
					return true;
				}

				return false;
			});
		};

    backOffice.Module({
        name: "Forms",
        init: function() {
            events();
            render();
        }
    });

	return $.extend(backOffice, {});

})(BackOffice || {}, jQuery);
